<template>
	<div class="order_record">
		<van-tabs v-model="active" background="transparent" color="#000" @change="activeChange">
			<van-tab title="全部" name=""></van-tab>
			<van-tab title="待支付" name="1"></van-tab>
			<van-tab title="已取消" name="3"></van-tab>
			<van-tab title="已支付" name="2"></van-tab>
		</van-tabs>

		<div class="content">
			<van-list v-if="total" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
				<record-list-item
					v-for="item in list"
					:key="item.id"
					class="mt-28"
					:title="item.name"
					:status="item.payStatus"
					:create-time="getItemTime(item)"
					:price="item.payPrice"
					@click="$router.push(`/order/detail/${ item.id }`)"
					@delete="clickDelete(item)"
					@preview="$router.push(`/order/detail/${ item.id }`)"
					@pay="$router.push(`/order/detail/${ item.id }`)"
				></record-list-item>
			</van-list>
			<base-empty v-else desc="暂无订单" :icon="0"></base-empty>
		</div>
	</div>
</template>

<script>
export default {
    name: 'orderRecord',
    data: () => ({
        active: 0,
        loading: false,
        payStatus: '',
        list: [],
        total: 0,
        page: 1,
        limit: 10,
    }),
    computed: {
        finished () {
            return this.total <= this.list.length
        },
        patientId () {
            return this.$route.params.id
        }
    },
    created () {
        this.getList()
    },
    methods: {
        // 切换 tab
        activeChange (name) {
            this.payStatus = name
            this.list = []
            this.page = 1
            this.total = 0
            this.getList()
        },
        async getList () {
            this.loading = true
            const res = await this.$api.order.getServiceList({
                limit: this.limit,
                page: this.page,
                payStatus: this.payStatus,
                patientId: this.patientId
            })
            this.loading = false
            if (!res.code) {
                this.list = [...this.list, ...res.data.list]
                this.total = res.data.total
                this.page++
            }
        },
        /**
         * @methods 获取创建时间
         * @params { object } data
         */
        getItemTime (data) {
            switch (data.payStatus + '') {
                case '2': return this.$utils.substrLastIndex(data.payTime, ':', true)
                case '3': return this.$utils.substrLastIndex(data.stopDate, ':', true)
                default: return this.$utils.substrLastIndex(data.gmtCreate, ':', true)
            }
        },
        // 点击删除
        clickDelete (item) {
            this.$dialog.confirm({
                message: '是否要删除吗？删除后无法恢复'
            }).then(async () => {
                await this.$api.order.deleteService(item.id)
                this.activeChange(this.payStatus)
                this.$toast('已删除')
            })
        },
    }
};
</script>

<style scoped lang="less">
.order_record {
	padding: 18px 32px;
}
</style>

<style lang="less">
.order_record {
	.van-tabs {
		.van-tabs__line {
			height: 4px;
		}
		.van-tab {
			.van-tab__text {
				font-family: PingFangSC-Regular;
				font-size: 32px;
				font-weight: normal;
				text-align: center;
				color: #bbbfc4;
			}
			&.van-tab--active {
				.van-tab__text {
					color: #000;
				}
			}
		}
	}
}
</style>
